import EMAILS from 'constants/email'

const EmailTemplates = {
	SIMPLE: `https://mail.google.com/mail/u/0/?fs=1&to=${EMAILS.support}&tf=cm`,
	RESET_PASSWORD: `https://mail.google.com/mail/u/0/?fs=1&to=${EMAILS.support}&tf=cm&su=Reset password&body=Dear Mr/Mrs%0AI am sending you this written notice to reset my password.`,
	WITHDRAW: `https://mail.google.com/mail/u/0/?fs=1&to=${EMAILS.support}&tf=cm&su=Withdraw`,
}

export default EmailTemplates
